export default __webpack_public_path__ + "maps-examples-default-styles-thumbnail-960-1abfcc2b1047e4e113ceffddd86091b5.png";